// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, clsx, Slot } from '@a-type/ui';
import { createContext, forwardRef, useContext, useState, } from 'react';
import { useMergedRef, useOnPointerDownOutside } from '../react.js';
import './MenuDisclose.css';
const MenuDiscloseContext = createContext({
    open: false,
    setOpen: () => { },
});
export const MenuDiscloseRoot = forwardRef(function MenuDiscloseRootImpl(_a, ref) {
    var { children, open: userOpen, onOpenChange, asChild, className } = _a, rest = __rest(_a, ["children", "open", "onOpenChange", "asChild", "className"]);
    const [internalOpen, setInternalOpen] = useState(false);
    const Comp = asChild ? Slot : 'div';
    const open = userOpen !== null && userOpen !== void 0 ? userOpen : internalOpen;
    const setOpen = (newOpen) => {
        if (userOpen === undefined) {
            setInternalOpen(newOpen);
        }
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(newOpen);
    };
    const outsideRef = useOnPointerDownOutside(() => {
        setOpen(false);
    });
    const finalRef = useMergedRef(ref, outsideRef);
    return (_jsx(MenuDiscloseContext.Provider, { value: { open, setOpen }, children: _jsxs(Comp, Object.assign({}, rest, { ref: finalRef, className: clsx('relative', 'menu-disclose-root', className), children: [children, open && (_jsx("div", { className: "opacity-0 bg-overlay fixed inset-0 z-0 pointer-events-none animate-fade-in animate-delay-200 animate-forwards" }))] })) }));
});
export const MenuDiscloseTrigger = forwardRef(function MenuDiscloseTriggerImpl(_a, ref) {
    var { children, asChild } = _a, rest = __rest(_a, ["children", "asChild"]);
    const { setOpen, open } = useContext(MenuDiscloseContext);
    const Comp = asChild ? Slot : DefaultButton;
    return (_jsx(Comp, Object.assign({}, rest, { ref: ref, className: clsx('pointer-events-auto', 'menu-disclose-trigger', 'bottom-0 left-1/2 transform -translate-x-1/2 pointer-events-auto', open && 'menu-disclose-trigger-hidden'), onClick: (ev) => {
            var _a;
            setOpen(!open);
            (_a = rest.onClick) === null || _a === void 0 ? void 0 : _a.call(rest, ev);
        }, children: children })));
});
const DefaultButton = forwardRef(function DefaultButton(_a, ref) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx(Button, Object.assign({ emphasis: "primary", className: clsx('absolute shadow-xl', className) }, props)));
});
export const MenuDiscloseContent = forwardRef(function MenuDiscloseContentImpl(_a, ref) {
    var { children, className, asChild } = _a, rest = __rest(_a, ["children", "className", "asChild"]);
    const { open } = useContext(MenuDiscloseContext);
    const [disableAnimation, setDisableAnimation] = useState(true);
    if (disableAnimation && open) {
        setDisableAnimation(false);
    }
    const Comp = asChild ? Slot : 'div';
    return (_jsx(Comp, Object.assign({}, rest, { ref: ref, className: clsx('relative z-1 border-default bg-white rounded-lg shadow-xl', 'menu-disclose-content', open ?
            'menu-disclose-content-visible pointer-events-auto'
            : 'menu-disclose-content-hidden pointer-events-none', disableAnimation && 'disable-animation', className), children: children })));
});
export const MenuDisclose = Object.assign(MenuDiscloseRoot, {
    Content: MenuDiscloseContent,
    Trigger: MenuDiscloseTrigger,
});
//# sourceMappingURL=MenuDisclose.js.map